module.exports = __webpack_public_path__ + "img/housefire_thumb.912bbaa7.jpg";